<template>
  <div class="form-buttons" :class="layout">
    <el-button v-if="hasTest" :id="testId" @click.native="emitAction('test')" :disabled="testDisabled">
      {{ $t(testLabel) }}
    </el-button>
    <el-button :id="cancelId" class="el-button--secondary" @click.native="emitAction('cancel')">
      {{ $t(cancelLabel) }}
    </el-button>
    <el-button
      :id="applyId"
      type="primary"
      @click.native="emitAction('apply')"
      :disabled="applyDisabled"
    >
      {{ $t(applyLabel) }}
    </el-button>
  </div>
</template>
<script>
export default {
  props: {
    layout: {
      type: String,
      default: "fixed",
    },
    hasTest: {
      type: Boolean,
      default: false,
    },
    testId: {
      type: String,
      default: "test",
    },
    cancelId: {
      type: String,
      default: "cancel",
    },
    applyId: {
      type: String,
      default: "apply",
    },
    testLabel: {
      type: String,
      default: "test_mark",
    },
    cancelLabel: {
      type: String,
      default: "cancel_mark",
    },
    applyLabel: {
      type: String,
      default: "apply_mark",
    },
    applyDisabled: {
      type: Boolean,
      default: false,
    },
    preventReclick: {
      type: Number,
      default: 0,
    },
    testDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitAction(type) {
      const pre_applyDisabled=this.applyDisabled;
      if(this.preventReclick != 0)
        this.applyDisabled=true;
      this.$emit(type, this.scope);
      if(this.preventReclick != 0)
      {
        setTimeout(() => {
          this.applyDisabled=pre_applyDisabled;
        },this.preventReclick)
      }
    },
  },
};
</script>
<style lang="scss">
@import "~@/styles/variables.scss";
.form-buttons {
  height: 74px;
  line-height: 74px;
  text-align: right;
  .el-button {
    min-width: $formButtonMinWidth;
    margin-right: 20px;
    margin-left: 0;
    height: 34px;
  }
}
.form-buttons.fixed {
  position: absolute;
  z-index: $pageButtonZIndex;
  bottom: 26px;
  left: 0;
  box-shadow: 0 2px 9px 0 #ccc;
  width: calc(100% - 20px);
}
.form-buttons.not-fixed {
  width: 100%;
  float: left;
  .el-button {
    margin-top: 0;
    height: 34px;
  }
}
.orbi.gui-2-1 {
  .form-buttons.fixed {
    top: 19px;
    box-shadow: none;
    width: 100%;
    text-align: center;
    height: 54px;
  }
}
.smb-gui.orbi.gui-2-1 {
  .form-buttons.fixed {
    width: calc(100% - 20px);
    top: 10px;
    height: 62px;
    border-bottom: solid 2px #9d98ff;
    .el-button {
      height: 30px;
      line-height: 1;
    }
  }
  .form-buttons.fixed.no-border{
    border-bottom: 0;
  }
}
</style>
